import { z } from 'zod'

export const chatConnectionFailedSchema = z.object({
  error: z.object({}),
  isRetry: z.boolean(),
})
